import Heading from 'src/elements/typography/heading'
import { palette } from 'src/styles/colors'
import { layout } from 'src/styles/layout'
import styled from 'styled-components'

export const PricingDetailsTableContainer = styled.table`
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;

  > tbody > tr > td {
    border: 1px solid #C6CBD3;
  }
`

export const PricingValue = styled(Heading)`
  position: relative;
  width: fit-content;
  justify-self: center;
  margin-left: -20px;

  &::before {
    content: "$";
    font-size: 1rem;
    position: absolute;
    top: -6px;
    left: -10px;
  }

  &::after {
    content: "/ mo";
    position: absolute;
    color: #6F7682;
    font-size: 1rem;
    bottom: 4px;
    right: -35px;
    font-weight: 400;
    line-height: 24px;
  }

  @media screen and (max-width: ${layout.sm}) {
    &::before {
      font-size: 0.5rem;
      top: -2px;
      left: -6px;
    }

    &::after {
      font-size: 0.75rem;
      bottom: -5px;
      right: -29px;
    }
  }
`

export const TableCellHeadPlanDetail = styled.div`
  display: grid;
  justify-content: center;
  box-sizing: border-box;
  grid-row-gap: 1rem;
  padding: 2rem;
  width: fit-content;
  margin: 0;

  @media screen and (max-width: ${layout.sm}) {
    grid-row-gap: 5px;
    padding: 0.5rem 0.5rem;
  }
`

export const TableRowPlanDetail = styled.tr`
  width: 100%;

  > th {
    border: 1px solid #C6CBD3;
  }

  th:first-child {
    background: transparent;
    width: 60%;
    border: unset;
  }

  @media screen and (max-width: ${layout.sm}) {
    th:first-child {
      width: auto;
    }
  }
`

export const TableRowTableTileHead = styled.tr`
  width: 100%;
  background-color: #F4F6FA;
  border: 1px solid #C6CBD3;
`

export const TableTitle = styled.div`
  display: grid;
  grid-template-columns: min-content 170px;
  justify-content: left;
  box-sizing: border-box;
  padding: 1.6rem 1rem;

  h1 {
    font-family: Lato;
  }

  > div {
    align-self: center;
  }

  @media screen and (max-width: ${layout.sm}) {
    grid-template-columns: min-content min-content;
  }
`

export const TableCellDetailContentExplain = styled.div`
  display: grid;
  justify-content: left;
  box-sizing: border-box;
  padding: .8rem 1rem;
  grid-row-gap: 8px;

  p:last-child {
    font-weight: 400;
    letter-spacing: -0.8px;
  }

  @media screen and (max-width: ${layout.sm}) {
    padding: .8rem 0.5rem;
  }
`

export const TablePlanCell = styled.td`
  width: 20%;

  > div {
    display: grid;
    justify-content: center;
  }

  > p {
    font-weight: 500;
  }

  svg path {
    fill: ${palette.pricingLightGreen};
  }

  @media screen and (max-width: ${layout.sm}) {
    width: 95px;
  }
`

export const TableCellRowTitle = styled.td`
  width: 60%;

  @media screen and (max-width: ${layout.md}) {
    width: auto;

    p:last-child {
      display: none;
    }
  }
`

export const HintContainer = styled.div`
  display: grid;
  width: 100%;
  justify-content: left;
  margin-right: auto;
  margin-top: -1rem;

  @media screen and (max-width: ${layout.sm}) {
    padding: 0 0.8rem;
    letter-spacing: -0.8px;
  }
`
